import React from 'react';
import {
	nullSafeGet,
	nullSafeGetOrElse,
	sanitizeCustomFieldName,
} from '../../utils/DataAccessUtils';
import { Form } from '@ant-design/compatible';
import { Input } from 'antd';

export default function CustomFieldItems({ getFieldDecorator, form, formData, customFields }) {
	if (!formData || !formData.id || nullSafeGet('length', customFields) < 0) {
		return null;
	}

	return customFields.map((field) => {
		getFieldDecorator(`custom-${sanitizeCustomFieldName(field.fieldName)}-fieldName`, {
			initialValue: field.fieldName,
		});
		getFieldDecorator(`custom-${sanitizeCustomFieldName(field.fieldName)}-valueType`, {
			initialValue: field.type || field.fieldType,
		});

		return (
			<Form.Item label={field.fieldName} key={field.fieldName}>
				{form.getFieldDecorator(
					`custom-${sanitizeCustomFieldName(field.fieldName)}-valueAsString`,
					{
						validateTrigger: ['onChange', 'onBlur'],
						initialValue:
							(
								nullSafeGetOrElse('customFieldDetails', formData, []).find(
									(i) => i.key === field.fieldName
								) || {}
							).valueAsString || '',
					}
				)(<Input style={{ maxWidth: 640 }} />)}
			</Form.Item>
		);
	});
}
